module.exports = __webpack_public_path__ + "img/Flexible Character.a55e8a1e.svg";